import Table from './Components/Table';

export default Table;
